import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {CheckBoxTable} from "../models/table.model";

@Injectable({
  providedIn: 'root'
})
export class CheckboxTableService {

  checkboxSelectAll$: Subject<boolean> = new Subject<boolean>()
  checkboxSelectItem$: Subject<CheckBoxTable> = new Subject<CheckBoxTable>()
  compareCount$: Subject<void> = new Subject<void>()

  constructor() {
  }
}
